import { render, staticRenderFns } from "./CardSortCombo.vue?vue&type=template&id=77b6a779"
import script from "./CardSortCombo.vue?vue&type=script&lang=js"
export * from "./CardSortCombo.vue?vue&type=script&lang=js"
import style0 from "./CardSortCombo.vue?vue&type=style&index=0&id=77b6a779&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports